import { makeRequest } from '../../../lib/api';

const CATALOG_PATH = '/v1/catalog';
const INSURANCE_PATH = '/v1/insurance/insurance_companies';
const VEHICLE_INSURANCES_PATH = '/v1/insurance/vehicle_insurances';

class insurancesController {
  getInsuranceCompanies = (data = {}) => {
    return makeRequest('get', `${ CATALOG_PATH }/insurance_companies`, data);
  };

  getInsuranceCompany = (id) => {
    return makeRequest('get', `${ CATALOG_PATH }/insurance_company/${ id }`);
  };

  getDeletedCompanies = () => {
    return makeRequest('get', `${ INSURANCE_PATH }/deleted`);
  };

  getNewCompanies = () => {
    return makeRequest('get', `${ INSURANCE_PATH }/new`);
  };

  getChangedCompanies = () => {
    return makeRequest('get', `${ INSURANCE_PATH }/changed`);
  };

  copyToInsuranceList = (idsForRemoval = []) => {
    return makeRequest('put', `${ INSURANCE_PATH }/copy`, { idsForRemoval });
  };

  getVehicleInsurancePolicies = (data) => {
    return makeRequest('get', `${ VEHICLE_INSURANCES_PATH }/vehicles/${ data.vehicleId }?activityStatus=${ data.activityStatus || 'all' }`, data);
  };

  createVehicleInsurancePolicy = (data) => {
    return makeRequest('post', `${ VEHICLE_INSURANCES_PATH }`, data);
  };

  updateVehicleInsurancePolicy = (data) => {
    return makeRequest('put', `${ VEHICLE_INSURANCES_PATH }/${ data.id }`, data);
  };

  deleteVehicleInsurancePolicy = (data) => {
    return makeRequest('delete', `${ VEHICLE_INSURANCES_PATH }/${ data.id }`, data);
  };
}

export default new insurancesController();
